import React from 'react';
import { Switch } from 'react-router-dom';
import SensorCapacityPageConnected from '../../../capacity/SensorCapacityPageConnected/SensorCapacityPageConnected';
import RaaRoute from '../../../common/RaaRoute';

function SensorCapacityPage() {
  /* istanbul ignore next */
  return (
    <Switch>
      <RaaRoute path="/s/sensor-capacity" exact>
        <SensorCapacityPageConnected />
      </RaaRoute>
    </Switch>
  );
}

export default SensorCapacityPage;
